import { ref, unref, watchEffect } from '@vue/composition-api'
import TicketCategoriaStatusChipEnum from '@/models/entities/ticket/TicketCategoriaStatusChipEnum'
import TicketService from '@/services/modules/TicketService'

function getChips() {
  return [
    {
      ativos: {
        text: 'Ativos',
        color: '#8E117B',
        value: TicketCategoriaStatusChipEnum.Ativos,
        qtd: 0,
      },
      novos: {
        text: 'Novos',
        color: 'accent',
        value: TicketCategoriaStatusChipEnum.Novos,
        qtd: 0,
      },
      andamento: {
        text: 'Andamento',
        color: 'accent',
        value: TicketCategoriaStatusChipEnum.Andamento,
        qtd: 0,
      },
    },
    {
      inativos: {
        text: 'Inativos',
        color: '#f73137',
        value: TicketCategoriaStatusChipEnum.Inativos,
        qtd: 0,
      },
      resolvidos: {
        text: 'Resolvidos',
        color: 'error',
        value: TicketCategoriaStatusChipEnum.Resolvidos,
        qtd: 0,
      },
      finalizados: {
        text: 'Finalizados',
        color: 'error',
        value: TicketCategoriaStatusChipEnum.Finalizados,
        qtd: 0,
      },
    },
  ]
}

export default function useTicketListCategoriaStatusChipGroups(filaId, atendenteId, filtros) {
  const chips = ref(getChips())

  watchEffect(async () => {
    const { email, protocolo, agenteSelecionado } = unref(filtros)
    const estatisticas = await TicketService.getEstatisticasFilaDeAtendimento(unref(filaId), email, protocolo, unref(atendenteId), agenteSelecionado)

    chips.value[0].ativos.qtd = estatisticas.ativos
    chips.value[0].novos.qtd = estatisticas.novos
    chips.value[0].andamento.qtd = estatisticas.andamento
    chips.value[1].inativos.qtd = estatisticas.inativos
    chips.value[1].resolvidos.qtd = estatisticas.resolvidos
    chips.value[1].finalizados.qtd = estatisticas.finalizados
  })

  return chips
}
